// frontend/src/Customers/Customers.jsx
import React, { useEffect, useState } from 'react';
import { getCustomers, deleteCustomer } from '../api/customerApi';
import { useNavigate } from 'react-router-dom';
import styles from './Customers.module.css';
import masaLogo from '../Assets/MasaLogo.png';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchCustomers = async () => {
    try {
      const response = await getCustomers();
      setCustomers(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch customers.');
    }
  };

  useEffect(() => {
    fetchCustomers();
    // eslint-disable-next-line
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this customer?')) return;
    try {
      await deleteCustomer(id);
      setCustomers(customers.filter((c) => c._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete customer.');
    }
  };

  return (
    <div className={styles.customersContainer}>
      <header className={styles.header}>
        <img src={masaLogo} alt="Dashboard Logo" className={styles.logo} />
        <h1 className={styles.pageTitle}>Manage Customers</h1>
      </header>

      <main className={styles.mainContent}>
        <div className={styles.topBar}>
          <button
            className={styles.addCustomerButton}
            onClick={() => navigate('/customers/new')}
          >
            + Add New Customer
          </button>
        </div>

        {error && <p className={styles.errorMessage}>{error}</p>}

        <div className={styles.customerList}>
          {customers.length === 0 ? (
            <p>No customers found. Add a new customer to get started.</p>
          ) : (
            <table className={styles.customerTable}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Customer ID</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((customer) => (
                  <tr key={customer._id}>
                    <td>{customer.name}</td>
                    <td>{customer.customerID}</td>
                    <td>
                      <button
                        className={styles.viewProfileButton}
                        onClick={() => navigate(`/customers/${customer._id}`)}
                      >
                        View Profile
                      </button>
                      <button
                        className={styles.deleteCustomerButton}
                        onClick={() => handleDelete(customer._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
};

export default Customers;
